import { DocumentType } from '@/shared/lib/sj-orm/models/document/document-base.dto';
import {
  PassportDto,
  PersonalIdentifierDocumentDto,
  PersonalIdentifierType,
} from '@/shared/lib/sj-orm/models/document/personal-identifier.document.dto';

export const isPassport = (
  document: PersonalIdentifierDocumentDto,
): document is PassportDto & PersonalIdentifierDocumentDto => {
  return (
    document.personalIdentifierType?.toLocaleLowerCase() ===
      PersonalIdentifierType.PASSPORT.toLocaleLowerCase() ||
    document.type?.toLocaleLowerCase() === DocumentType.PASSPORT.toLocaleLowerCase()
  );
};
